/*
 * @Descripttion: 
 * @version: 
 * @Author: leon
 * @email: leon0023@zoho.com.cn
 * @Date: 2022-09-01 17:32:11
 * @LastEditors: K
 * @LastEditTime: 2022-09-05 11:30:51
 */
import React, { ReactElement, useEffect, useState } from 'react';
import { EditableList } from '../../compnents/list/EditableList';
import styles from "./diseaseSetPage.module.css";
import { Query } from './query';
import { Columns } from "./columns";
import { Button, Form, Input, Modal, notification, Radio, Row, Select, Space } from 'antd';
import { stringTrim } from '../../utils/StringUtils';
import { useDispatch } from 'react-redux';
import { RootDispatch } from '../../app/store';
import { unwrapResult } from '@reduxjs/toolkit';
import { getTabelList, saveIllnessAsync } from '../insurance/InsuranceSlice';
import cnchar from 'cnchar';

export const DiseaseSetPage = (): ReactElement => {

  const dispatch = useDispatch<RootDispatch>()

  const [editForm] = Form.useForm()

  const [params, setParams] = useState<any>({
    current: 0,
    size: 10,
  })

  const [page, setPage] = useState<any>({
    total: 0,
    items: [],
  })

  const [pageLoading, setPageLoading] = useState(false)   //表格 loading

  const [modalVisibal, setModalVisibal] = useState(false) //弹窗 loading

  const [modalVisibalBtn, setModalVisibalBtn] = useState(false) //弹窗 loading

  const [editId, setEditId] = useState('')

  const getList = () => {
    setPageLoading(true)
    dispatch(getTabelList(params))
      .then(unwrapResult)
      .then((res: any) => {
        setPage({
          total: res.total,
          items: res.records,
        })
      })
      .finally(() => setPageLoading(false))
  }

  useEffect(() => {
    params.current && getList()
  }, [params])



  const rules = [
    {
      required: true
    }
  ]
  const close = () => {
    setModalVisibal(false)
    editForm.resetFields()
  }
  return (
    <div className={styles.content}>

      {/* 查询区域 */}
      <Query
        onSubmit={(obj) => {
          setParams({
            ...params,
            ...obj,
            current: 1
          })

        }}
      />

      {/* 表格区域 */}
      <div className={styles.tableWrap}>
        <EditableList
          page={{
            current: params.current,
            size: params.size,
            total: page.total,
            items: page.items,
          }}
          loading={pageLoading}
          className={styles.table}
          columns={Columns(
            (t: any) => {
              setEditId(t.id)
              editForm.setFieldsValue({
                ...t,
                listType: Number(t.listType),
                icds: t.code
              })
              setModalVisibal(true)

            },
            params.size * (params.current - 1),
          )}
          onChangePage={(current: number, size?: number) => setParams({
            ...params,
            current,
            size
          })}
        />
      </div>


      {/* 弹窗区域 */}
      <Modal
        title='编辑疾病目录'
        visible={modalVisibal}
        onCancel={close}
        footer={null}
      >
        <Form
          form={editForm}
          onFinish={(values) => {
            setModalVisibalBtn(true)
            dispatch(saveIllnessAsync({ ...values, id: editId, diagZjm: values.zjm }))
              .then(unwrapResult)
              .then((res: any) => {
                notification.success({
                  message: res
                })
                close()
                getList()

              })
              .finally(() => setModalVisibalBtn(false))
          }}
          // initialValues={{
          //   listType: 1,
          //   category: 0,
          // }}
          labelCol={{ span: 6 }}
          wrapperCol={{ span: 18 }}
        >
          <Form.Item name='listType' label="目录类别" rules={rules}>
            <Radio.Group disabled>
              <Radio value={0} disabled> 医保目录 </Radio>
              <Radio value={1}> 自费目录 </Radio>
            </Radio.Group>
          </Form.Item>
          <Form.Item name='icds' label="疾病编码" rules={rules} getValueFromEvent={stringTrim}>
            <Input placeholder='请输入疾病编码' disabled maxLength={116} />
          </Form.Item>
          <Form.Item name='name' label="疾病名称" rules={rules} getValueFromEvent={stringTrim}>
            <Input placeholder='请输入疾病名称' disabled maxLength={16} onInput={(e: any) => {
              editForm.setFieldsValue({
                mnemonicCode: cnchar.spell(e.
                  target.value, 'first'),
              })
            }} />
          </Form.Item>
          <Form.Item name='zjm' label="助记码" rules={rules} getValueFromEvent={stringTrim}>
            <Input placeholder='请输入助记码' maxLength={116} />
          </Form.Item>
          <Form.Item name='category' label="疾病类型" rules={rules}>
            <Radio.Group disabled>
              <Radio value={0}> 普通病 </Radio>
              <Radio value={1}> 特殊病 </Radio>
              <Radio value={2}> 慢性病 </Radio>
            </Radio.Group>
          </Form.Item>
        </Form>
        <Row justify='end'>
          <Space>
            <Button onClick={() => setModalVisibal(false)}>
              取消
            </Button>
            <Button type='primary' loading={modalVisibalBtn} onClick={() => {
              editForm.submit()
            }}>
              确认
            </Button>
          </Space>
        </Row>
      </Modal>
    </div>
  );
}
